function Second() {
  return <p>Second page yeah!</p>;
}

export default Second;
